(function() {
  'use strict';

  var API_BASE = 'https://ai.marlotbaus.com/api/shopify/product-specs';
  var specsCache = {};
  var variantSkuMap = null;
  var specsTranslations = null;

  function getLocale() {
    return (window.Shopify && window.Shopify.locale) ? window.Shopify.locale : 'es';
  }

  function loadTranslations() {
    if (specsTranslations) return specsTranslations;
    var el = document.getElementById('specs-translations');
    if (el) {
      try {
        specsTranslations = JSON.parse(el.textContent);
      } catch (e) {
        specsTranslations = {};
      }
    }
    return specsTranslations || {};
  }

  function t(key) {
    var tr = loadTranslations();
    return tr[key] || key;
  }

  function normalizeKey(raw) {
    return raw.toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[áà]/g, 'a')
      .replace(/[éè]/g, 'e')
      .replace(/[íì]/g, 'i')
      .replace(/[óò]/g, 'o')
      .replace(/[úù]/g, 'u')
      .replace(/[^a-z0-9_]/g, '');
  }

  function translateEnum(prefix, rawValue) {
    if (!rawValue) return null;
    var key = prefix + '_' + normalizeKey(rawValue);
    var translated = t(key);
    return translated !== key ? translated : rawValue.toLowerCase();
  }

  function translateMaterial(raw) {
    if (!raw) return null;
    var parts = raw.split(/ o /i);
    var translated = parts.map(function(part) {
      var key = 'mat_' + normalizeKey(part.trim());
      var val = t(key);
      return val !== key ? val : part.trim().toLowerCase();
    });
    return translated.join(' ' + t('fmt_or') + ' ');
  }

  function loadVariantSkuMap() {
    if (variantSkuMap) return variantSkuMap;
    var el = document.getElementById('variant-sku-map');
    if (el) {
      try {
        variantSkuMap = JSON.parse(el.textContent);
      } catch (e) {
        variantSkuMap = {};
      }
    }
    return variantSkuMap || {};
  }

  function getSkuFromVariantId(variantId) {
    var map = loadVariantSkuMap();
    return map[variantId] || null;
  }

  function extractParentSku(sku) {
    if (!sku) return null;
    var parts = sku.split('-');
    if (parts.length > 2) {
      return parts.slice(0, 2).join('-');
    }
    return sku;
  }

  function getCurrentVariantSku() {
    var btn = document.getElementById('AddToCart');
    if (btn) {
      var variantId = btn.getAttribute('data-id');
      if (variantId) {
        var sku = getSkuFromVariantId(variantId);
        if (sku) return sku;
      }
    }
    var section = document.querySelector('[data-product-sku]');
    return section ? section.getAttribute('data-product-sku') : null;
  }

  function fetchSpecs(sku, callback) {
    var parentSku = extractParentSku(sku);
    var cacheKey = parentSku;

    if (specsCache[cacheKey]) {
      callback(specsCache[cacheKey]);
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', API_BASE + '?sku=' + encodeURIComponent(parentSku));
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 200) {
        try {
          var data = JSON.parse(xhr.responseText);
          specsCache[cacheKey] = data;
          callback(data);
        } catch (e) {
          console.warn('[specs] Parse error:', e);
        }
      }
    };
    xhr.onerror = function() {
      console.warn('[specs] Network error');
    };
    xhr.send();
  }

  function updateSpecField(attr, value) {
    var els = document.querySelectorAll('[data-spec="' + attr + '"]');
    els.forEach(function(el) {
      var container = el.closest('.specs-hero__item') || el.closest('.specs-detail__item');
      if (value) {
        el.innerHTML = value.replace(/\n/g, '<br>');
        if (container) container.style.display = '';
      } else {
        el.innerHTML = '';
        if (container) container.style.display = 'none';
      }
    });
  }

  function updateComensales(seating) {
    var el = document.getElementById('product-comensales');
    if (!el) return;
    if (seating) {
      var label = el.getAttribute('data-label') || 'comfortably';
      el.textContent = seating + ' ' + label;
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function updateDownloads(docs) {
    if (!docs) return;

    var datasheetRow = document.querySelector('[data-download="datasheet"]');
    var assemblyRow = document.querySelector('[data-download="assembly"]');

    if (datasheetRow) {
      if (docs.datasheet) {
        datasheetRow.href = docs.datasheet;
        datasheetRow.target = '_blank';
        datasheetRow.style.display = '';
      } else {
        datasheetRow.style.display = 'none';
      }
    }

    if (assemblyRow) {
      if (docs.assembly) {
        assemblyRow.href = docs.assembly;
        assemblyRow.target = '_blank';
        assemblyRow.style.display = '';
      } else {
        assemblyRow.style.display = 'none';
      }
    }

    var model3dRow = document.querySelector('[data-download="model3d"]');
    if (model3dRow) {
      if (docs.model3d) {
        model3dRow.href = docs.model3d;
        model3dRow.target = '_blank';
        model3dRow.style.display = '';
      } else {
        model3dRow.style.display = 'none';
      }
    }
  }

  function formatSurface(s) {
    var parts = [];
    if (s.lengthCm && s.widthCm && s.heightCm) {
      parts.push(s.lengthCm + ' × ' + s.widthCm + ' × ' + s.heightCm + ' cm');
    }
    if (s.surfaceThicknessCm) {
      parts.push(t('fmt_thickness') + ' ' + s.surfaceThicknessCm + ' cm');
    }
    if (s.surfaceShape) {
      parts.push(t('fmt_shape') + ' ' + translateEnum('shape', s.surfaceShape));
    }
    if (s.edgeType) {
      parts.push(t('fmt_edge') + ' ' + translateEnum('edge', s.edgeType));
    }
    return parts.join('<br>') || null;
  }

  function formatLegs(s) {
    var parts = [];
    if (s.legCount && s.legShape) {
      var desc = t('fmt_legs_desc')
        .replace('{count}', s.legCount)
        .replace('{shape}', translateEnum('leg', s.legShape));
      parts.push(desc);
    } else if (s.legCount) {
      parts.push(s.legCount + ' ' + t('fmt_legs'));
    }
    if (s.legDiameter) {
      parts.push('Ø ' + s.legDiameter + ' cm');
    }
    if (s.legHeightCm) {
      parts.push(t('fmt_height') + ' ' + s.legHeightCm + ' cm');
    }
    return parts.join('<br>') || null;
  }

  function formatWeight(s) {
    var parts = [];
    if (s.surfaceWeightKg) {
      parts.push(t('fmt_surface_label') + ' ' + s.surfaceWeightKg + ' kg');
    }
    if (s.legWeightKg) {
      parts.push(t('fmt_each_leg') + ' ' + s.legWeightKg + ' kg');
    }
    return parts.join('<br>') || null;
  }

  function formatMaterials(s) {
    var parts = [];
    if (s.surfaceMaterial) {
      parts.push(t('fmt_surface_in') + ' ' + translateMaterial(s.surfaceMaterial));
    }
    if (s.legMaterialOptions) {
      parts.push(t('fmt_legs_in') + ' ' + translateMaterial(s.legMaterialOptions));
    }
    return parts.join('<br>') || null;
  }

  function formatShipping(s) {
    var parts = [];
    var total = s.packageCount || 0;
    if (total > 0) {
      var details = [];
      var surfaceCount = total - (s.legPackageCount || 0);
      if (surfaceCount > 0) details.push(surfaceCount + ' ' + t('fmt_package_surface'));
      if (s.legPackageCount) details.push(s.legPackageCount + ' ' + t('fmt_package_legs'));
      parts.push(total + ' ' + t('fmt_packages') + '<br>(' + details.join(' + ') + ')');
    }
    parts.push(t('fmt_packaging_detail'));
    return parts.join('<br>');
  }

  function formatDimensionsShort(s) {
    if (s.lengthCm && s.widthCm) {
      return s.lengthCm + '×' + s.widthCm;
    }
    return null;
  }

  function getMaterialCategory(surfaceMaterial) {
    if (!surfaceMaterial) return 'microcemento';
    var n = surfaceMaterial.toLowerCase();
    if (n.indexOf('cristal') > -1 || n.indexOf('vidrio') > -1 || n.indexOf('glass') > -1) return 'cristal';
    if (n.indexOf('acero') > -1 || n.indexOf('steel') > -1) return 'acero';
    if (n.indexOf('madera') > -1 || n.indexOf('chapa') > -1 || n.indexOf('wood') > -1) return 'madera';
    return 'microcemento';
  }

  function updateDetailsContent(specs) {
    var el = document.getElementById('details-translations');
    if (!el) return;
    try {
      var data = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    var cat = getMaterialCategory(specs.surfaceMaterial);

    // text_1 — intro based on surface material category
    var text1 = document.querySelector('.product-details--info__text-1');
    if (text1 && data.intro && data.intro[cat]) {
      text1.innerHTML = data.intro[cat];
    }

    // text_2 — MATERIALS composed from surfaceMaterial + legMaterialOptions
    var text2 = document.querySelector('.product-details--info__text-2');
    if (text2 && data.surface_desc && data.legs_desc) {
      var surfaceKey = normalizeKey(specs.surfaceMaterial || 'Microcemento');
      var surfaceDesc = data.surface_desc[surfaceKey] || null;
      var header = data.materials_header || 'MATERIALS';
      var html = '<p>' + header + '</p>';
      if (surfaceDesc) {
        html += '<p>' + surfaceDesc;
        if (specs.legMaterialOptions) {
          var legsKey = normalizeKey(specs.legMaterialOptions);
          var legsDesc = data.legs_desc[legsKey] || null;
          if (legsDesc) html += ' ' + legsDesc;
        }
        html += '</p>';
      }
      text2.innerHTML = html;
    }

    // text_3 — protection based on surface material category
    var text3 = document.querySelector('.product-details--info__text-3');
    if (text3 && data.protection && data.protection[cat]) {
      text3.innerHTML = data.protection[cat];
    }
  }

  function renderSpecs(data) {
    if (!data || !data.specs) return;
    if (data.category === 'sample') return;

    var s = data.specs;

    updateSpecField('dimensions_short', formatDimensionsShort(s));
    updateSpecField('seating', s.seating);
    updateSpecField('surface', formatSurface(s));
    updateSpecField('materials', formatMaterials(s));
    updateSpecField('legs', formatLegs(s));
    updateSpecField('weight', formatWeight(s));
    updateSpecField('shipping', formatShipping(s));
    updateSpecField('resistance', t('fmt_resistance_text'));
    updateSpecField('standards', t('fmt_standards_text'));
    updateSpecField('manufacturing', t('fmt_manufacturing_text'));

    updateComensales(s.seating);
    updateDownloads(data.docs);
    updateDetailsContent(s);
  }

  function fetchAndRender() {
    var sku = getCurrentVariantSku();
    if (!sku) return;
    fetchSpecs(sku, renderSpecs);
  }

  function init() {
    fetchAndRender();
  }

  function isSizeOption(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    return n.indexOf('largo') > -1 || n.indexOf('size') > -1 ||
           n.indexOf('taille') > -1 || n.indexOf('dimensions') > -1 ||
           n.indexOf('medida') > -1 || n.indexOf('long') > -1;
  }

  function syncSpecsSizeSelector(value) {
    var dropdown = document.getElementById('specs-dim-dropdown');
    if (!dropdown) return;
    dropdown.querySelectorAll('.specs-dim-dropdown__option').forEach(function(btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-value') === value);
    });
  }

  function initSpecsSizeSelector() {
    var dropdown = document.getElementById('specs-dim-dropdown');
    if (!dropdown) return;
    var optionName = dropdown.getAttribute('data-option-name');
    if (!optionName) return;

    // Stop all clicks inside dropdown from closing the panel
    dropdown.addEventListener('click', function(e) { e.stopPropagation(); });

    // Toggle menu on trigger click
    dropdown.querySelector('.specs-dim-dropdown__trigger').addEventListener('click', function() {
      dropdown.classList.toggle('is-open');
    });

    // Close menu when clicking outside
    document.addEventListener('click', function() {
      dropdown.classList.remove('is-open');
    });

    // Handle option selection
    dropdown.querySelectorAll('.specs-dim-dropdown__option').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var value = btn.getAttribute('data-value');
        // Update active state
        dropdown.querySelectorAll('.specs-dim-dropdown__option').forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
        });
        dropdown.classList.remove('is-open');
        // Sync to main selector
        var mainRadios = document.querySelectorAll('input.variant_option[name="' + optionName + '"]');
        mainRadios.forEach(function(radio) {
          if (radio.value === value && !radio.checked) {
            radio.checked = true;
            if (window.jQuery) {
              jQuery(radio).triggerHandler('click');
            }
          }
        });
        setTimeout(fetchAndRender, 300);
      });
    });
  }

  function listenForVariantChanges() {
    var addToCartBtn = document.getElementById('AddToCart');
    if (addToCartBtn) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'data-id') {
            fetchAndRender();
          }
        });
      });
      observer.observe(addToCartBtn, { attributes: true });
    }

    document.addEventListener('change', function(e) {
      var target = e.target;
      if (target.matches && target.matches('input[type="radio"]')) {
        var name = target.getAttribute('name');
        if (name && isSizeOption(name) && name !== 'specs_size') {
          syncSpecsSizeSelector(target.value);
          setTimeout(function() {
            fetchAndRender();
          }, 300);
        }
      }
    });

    initSpecsSizeSelector();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      listenForVariantChanges();
    });
  } else {
    init();
    listenForVariantChanges();
  }
})();
